import React, { ReactNode } from "react";

import NotFoundIcon from "../../icons/services/404";
import SearchIcon from "../../icons/services/Search";
import SelectedIcon from "../../icons/services/Selcted";
import styles from "./EmptyState.module.scss";

type EmptyStateVariant = "favorites" | "search" | "notFound";

interface EmptyStateProps {
  text: ReactNode;
  variant: EmptyStateVariant;
  className?: string;
}

const icons: Record<EmptyStateVariant, ReactNode> = {
  favorites: <SelectedIcon className={styles.favoritesIcon} aria-hidden="true" />,
  search: <SearchIcon className={styles.searchIcon} aria-hidden="true" />,
  notFound: <NotFoundIcon className={styles.notFoundIcon} aria-hidden="true" />,
};

const EmptyState = ({ text, variant, className = "" }: EmptyStateProps) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      {icons[variant]}
      <span>{text}</span>
    </div>
  );
};

export default EmptyState;
